import { slugify } from 'utils/string-helpers';

const attributeColumn = {
  key: 'attribute',
  title: 'Attribute',
  isSortable: false
};

export default benchmarks => {
  return [
    attributeColumn,
    ...benchmarks.map(benchmark => ({
      key: slugify(benchmark.name),
      title: benchmark.name,
      isSortable: true
    }))
  ];
};
